module.exports = __webpack_public_path__ + "img/project_screenshot_1.dbd76f21.webp";